import styles from './styles.less';



/** WEBPACK FOOTER **
 ** ./src/components/preloader.css/index.js
 **/